import {Component, EventEmitter, forwardRef, OnInit, Output, ViewChild} from '@angular/core';
import {AbstractControl, ControlValueAccessor, Form, FormControl, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR, NgModel, ValidationErrors, Validator, Validators} from "@angular/forms";
import {CountryISO, NgxIntlTelInputComponent, PhoneNumberFormat, SearchCountryField} from 'ngx-intl-tel-input';
import {isString} from "@qntm-code/utils";

@Component({
  selector: 'app-international-phone-number',
  templateUrl: './international-phone-number.component.html',
  styleUrls: ['./international-phone-number.component.css'],
  providers: [{provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => InternationalPhoneNumberComponent), multi: true},

    {provide: NG_VALIDATORS, useExisting: InternationalPhoneNumberComponent, multi: true}
  ]
})
export class InternationalPhoneNumberComponent implements ControlValueAccessor, OnInit, Validator {

  @Output() handleChange: EventEmitter<any> = new EventEmitter();

  SearchCountryField = SearchCountryField;
  PhoneNumberFormat = PhoneNumberFormat;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates];

  MaxPhoneNumberLength = 15;

  nationalNumber: string;
  internationalNumber: string;
  number: string;
  isDisabled: boolean = false;

  @ViewChild("phone") phone: NgModel;

  onChange: any = () => {
    this.handleChange.emit();
  };

  onTouch: any = (_: any) => {
  };

  constructor() {
  }

  ngOnInit(): void {
  }

  registerOnChange(fn: any): void {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void {
  }

  // reverse engineer to show national number
  writeValue(value: any) {
    if (value) {
      if (isString(value)) {  // initial ngModel string input
        this.nationalNumber = value;
      } else {                // any subsequent call back
        if (this.internationalNumber !== value.internationalNumber || (this.number !== value.number)) {
          this.number = value.number;
          if (this.number != "" && value.nationalNumber == "") {
            this.nationalNumber = this.number;
          } else {
            this.nationalNumber = value.nationalNumber;
          }
          if (this.number != "" && value.internationalNumber == "") {
            this.internationalNumber = this.number;
          } else {
            this.internationalNumber = value.internationalNumber;
          }
          this.onChange(this.internationalNumber);
        }
      }
    }
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return this.phone?.errors;
  }



  onClickClearPhoneNumber() {
    this.number = null;
    this.nationalNumber = null;
    this.internationalNumber = null;
    this.onChange();
  }

  showAll(phone) {
    console.log(phone);
  }

}
